import { Mouvement } from '@mairistem/comptabilite';
import BordereauStateStep from '../../../constants/liquidation/bordereaux/BordereauStateStep';
import BordereauStateType from '../../../constants/liquidation/bordereaux/BordereauStateType';
import BordereauActionType from '../../../interfaces/pieces/bordereaux/BordereauActionType';
import MouvementActionType from '../../../interfaces/pieces/mouvements/liquidation/MouvementActionType';
import { BordereauWithState } from '../../../interfaces/pieces/TreeRow';
import type BaseLiquidationAction from '../../pieces/BaseLiquidationAction';
import BordereauDupliquerAction from '../actions/BordereauDupliquerAction';
import BordereauModifierAction from '../actions/BordereauModifierAction';
import BordereauNumeroterAction from '../actions/BordereauNumeroterAction';
import BaseBordereauState from './BaseBordereauState';
import MouvementSupprimerAction from '../../mouvements/liquidation/actions/MouvementSupprimerAction';
import MouvementModifierAction from '../../mouvements/liquidation/actions/MouvementModifierAction';
import BordereauSupprimerAction from '../actions/BordereauSupprimerAction';
import { TYPE_BORDEREAU } from '../../../constants/mouvements/typeBordereau';
import MouvementDupliquerAction from '../../mouvements/liquidation/actions/MouvementDupliquerAction';

class BordereauEnCoursState extends BaseBordereauState {
  constructor() {
    super();
    this.step = BordereauStateStep.EN_COURS;
    this.state = BordereauStateType.EN_COURS;
    this.color = '#0D99FF';
    this.libelle = 'En-cours';
  }

  getBordereauActions(bordereau: BordereauWithState): BaseLiquidationAction<BordereauWithState, BordereauActionType>[] {
    if (bordereau.typePes === TYPE_BORDEREAU.REJET) {
      return [
        new BordereauNumeroterAction({ isActionPrincipale: true, isRejet: bordereau.typePes === TYPE_BORDEREAU.REJET }),
        new BordereauSupprimerAction(),
        new BordereauModifierAction(),
      ];
    }

    return [
      new BordereauNumeroterAction({ isActionPrincipale: true }),
      new BordereauModifierAction(),
      new BordereauSupprimerAction(),
      new BordereauDupliquerAction(),
    ];
  }

  getMouvementActions(): BaseLiquidationAction<Mouvement, MouvementActionType>[] {
    return [
      new MouvementModifierAction({ isReadonly: true }),
      new MouvementModifierAction(),
      new MouvementDupliquerAction(),
      new MouvementSupprimerAction(),
    ];
  }
}

export default BordereauEnCoursState;
